const awsmobile = {
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_iP2TUEJmw",
    "aws_user_pools_web_client_id": "oq97kdmu6vm9ubl0pojohhj8b",
    "oauth": {}
};
export default awsmobile;